<template>
  <div>
    <LoaderWithText
      v-if="firmStore.isFetching || !firmStore.hasFetched"
      class="stk-px-6"
    >
      Loading…
    </LoaderWithText>

    <template v-else>
      <div
        class="stk-px-6 stk-pb-4"
      >
        <Title>
          {{ firmStore.advisors.length }}
          <span v-if="firmStore.advisors.length > 1">Advisors</span>
          <span v-else>Advisor</span>
        </Title>
      </div>

      <template v-if="firmStore.advisors?.length > 0">
        <table class="stk-table">
          <thead class="stk-table-head">
            <tr>
              <th class="stk-table-head-col">
                Name
              </th>
              <th class="stk-table-head-col">
                Email
              </th>
              <th class="stk-table-head-col">
                Role
              </th>
              <th class="stk-table-head-col">
                Can create teams?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(advisor) in firmStore.advisors"
              :key="advisor.id"
              class="stk-table-row"
            >
              <td class="stk-table-cell cell-name">
                <strong class="stk-table-cell-name">{{ advisor.name }}</strong>
              </td>
              <td class="stk-table-cell cell-email">
                {{ advisor.email }}
              </td>
              <td class="stk-table-cell cell-role">
                <Badge v-if="advisor.is_firm_admin" status="warning">
                  Admin
                </Badge>
                <Badge v-else status="info">
                  Advisor
                </Badge>
              </td>
              <td class="stk-table-cell cell-can-create">
                <YesNoBadge :bool="advisor.is_firm_admin || advisor.can_create_teams" />
                <Button
                  v-if="advisorStore.advisor.id !== advisor.id && canChangePrivileges"
                  badge
                  :disabled="firmStore.isUpdatingAdvisor.includes(advisor.external_id)"
                  @click="firmStore.updateAdvisorPrivileges(advisor.external_id, { can_create_teams: !advisor.can_create_teams })"
                >
                  Change
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>

      <div
        v-else
        class="stk-px-6"
      >
        <Callout
          status="primary"
        >
          <p>No advisor found</p>
        </Callout>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { YesNoBadge, Badge, Button, Callout, LoaderWithText, Title } from '@stakeui';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { useFirmStore } from '@frontend/ui/stores/firmStore.js';

const advisorStore = useAdvisorStore();
const firmStore = useFirmStore();

const canChangePrivileges = computed(() => advisorStore.advisor?.is_firm_admin);

onMounted(() => {
  if (firmStore.hasFetched) {
    return;
  }

  firmStore.fetchAdvisors();
});
</script>

<style scoped>
.cell-name {
  color: var(--stk-text-strong);
  width: 16rem;
}

.cell-description {
  width: auto;
}

.cell-date {
  color: var(--stk-text-normal);
  font-size: 0.75em;
  width: 12rem;
}

.cell-role,
.cell-can-create {
  width: 12rem;
}
</style>
